import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import UIDialogFooter from 'UIComponents/dialog/UIDialogFooter';
import ShareViaStepIndicator from '../ShareViaStepIndicator';
import ConfigurationStepContent from './ConfigurationStepContent';
import ConfigurationStepFooter from './ConfigurationStepFooter';
// @ts-expect-error: no types
import { useControlsContext } from '../../../shareAsset/context';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const ConfigurationStepContainer = () => {
  const {
    isEditingScheduledEmail
  } = useControlsContext();
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(UIDialogBody, {
      children: [!isEditingScheduledEmail && /*#__PURE__*/_jsx(ShareViaStepIndicator, {}), /*#__PURE__*/_jsx(ConfigurationStepContent, {})]
    }), /*#__PURE__*/_jsx(UIDialogFooter, {
      children: /*#__PURE__*/_jsx(ConfigurationStepFooter, {})
    })]
  });
};
export default ConfigurationStepContainer;